import { render } from "./EditCommandeFournisseur.vue?vue&type=template&id=0859d8c2&scoped=true&ts=true"
import script from "./EditCommandeFournisseur.vue?vue&type=script&lang=ts"
export * from "./EditCommandeFournisseur.vue?vue&type=script&lang=ts"

import "./EditCommandeFournisseur.vue?vue&type=style&index=0&id=0859d8c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0859d8c2"]])

export default __exports__